/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

// import axios from '@/axios.js'
import store from "@/store/store";

export default {
  addNote({ commit }, note) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("notes/create", note)
        .then(res => {
          commit("ADD_ITEM", res.data);
          commit("SET_NOTES", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("note create failed", err);
          reject(err);
        });
    });
  },
  fetchNotes({ commit }, query) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("notes/find",query)
        .then(res => {
          commit("SET_NOTES", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("notes could not be found", err);
          reject(err);
        });
    });
  },
  updateNote(context, note) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("notes/patch", [note.id, note])
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("note could not be found", err);
          reject(err);
        });
    });
  },
  removeRecord({ commit }, dataObj) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("notes/patch", [dataObj.id, dataObj])
        .then(res => {
          commit("REMOVE_RECORD", dataObj.id);
          resolve(res);
        })
        .catch(err => {
          console.log("The selected Note could not be deleted", err);
          reject(err);
        });
    });
  }
};
